"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../helpers");
if (window.__CONFIG__) {
    __webpack_public_path__ = helpers_1.ensureSlash(window.__CONFIG__.platform.publicUrl);
}
//# sourceMappingURL=setPublicPath.js.map